import { supabase } from '../../lib/supabase'

export const customizationStudioProvider = {
  async searchUsers(tenantId: string, query: string) {
    return supabase.rpc('search_workspace_customization_users', { p_tenant_id: tenantId, p_query: query })
  },
  async listRolePresets() {
    const [presets, assignments] = await Promise.all([
      supabase.from('role_presets').select('role_id,version').eq('status', 'active').order('role_id'),
      supabase.from('role_preset_capabilities').select('role_id,preset_version,capability_id').order('capability_id'),
    ])
    if (presets.error) return { data: null, error: presets.error }
    if (assignments.error) return { data: null, error: assignments.error }
    return { data: { presets: presets.data ?? [], assignments: assignments.data ?? [] }, error: null }
  },
  async assignRole(input: {
    tenantId: string
    userId: string
    roleId: string
    presetVersion: number
    effectiveAt: string
    reason: string
    correlationId: string
  }) {
    return supabase.rpc('assign_workspace_role', {
      p_tenant_id: input.tenantId,
      p_user_id: input.userId,
      p_role_id: input.roleId,
      p_preset_version: input.presetVersion,
      p_effective_at: input.effectiveAt,
      p_reason: input.reason,
      p_correlation_id: input.correlationId,
    })
  },
  async activateUserOverride(input: {
    tenantId: string
    userId: string
    payload: Record<string, unknown>
    reason: string
    correlationId: string
  }) {
    return supabase.rpc('activate_configuration_version', {
      p_tenant_id: input.tenantId,
      p_scope_type: 'user',
      p_scope_key: input.userId,
      p_schema_version: 1,
      p_payload: input.payload,
      p_reason: input.reason,
      p_correlation_id: input.correlationId,
    })
  },
}
